import { Link } from "react-router-dom";
import useDocumentTitle from "../hooks/useDocumentTitle";

/** Shown for any URL that doesn't match a page or project slug. */
export default function NotFoundPage() {
  useDocumentTitle("Not found");

  return (
    <div className="not-found">
      <p className="mono">#404</p>
      <p>Page not found.</p>
      <Link to="/" className="back-link mono">
        ← Portfolio
      </Link>
    </div>
  );
}
